import {CardStatus} from "./enums/cart-enums";
import ItemLocation from "./item-location";

export default class Cart {

    constructor() {
        this.id = "cartId";
        this.label = "cartLabel1";
        this.capacity = 40;
        this.readyForStaging = false;
        this.status = CardStatus.ACTIVE;
        this.location = new ItemLocation();
        this.isReadyForStaging = true;
        this.sequence = 1;
    }
}



// WEBPACK FOOTER //
// ./src/models/cart.js